import React from "react";

/** HealthCircles brand mark. Uses currentColor so the parent controls tint. */
export default function HealthCirclesLogo({ size = 24, className = "", ...rest }) {
  return (
    <svg
      role="img"
      aria-label="HealthCircles"
      focusable="false"
      viewBox="0 0 29.319 30.2"
      width={size}
      height={size}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M28.4 20.33a11.154 11.154 0 01-14.35 4.881 10.07 10.07 0 001.5.118 10.232 10.232 0 10-2.42-20.143A11.2 11.2 0 0128.4 20.33zM5.02 18.971A14.131 14.131 0 0118.569.847a13.9 13.9 0 012.576.249A14.936 14.936 0 0015.563 0a15.1 15.1 0 104.263 29.581 15.437 15.437 0 002.527-1.007 14.082 14.082 0 01-17.332-9.6zm8.874-9.656v3.714h-3.713v3.9h3.713v3.713h3.9v-3.718H21.5v-3.9h-3.71v-3.71z"
        fill="currentColor"
        transform="translate(-.452)"
      />
    </svg>
  );
}
